/*

* Common permissions *
1 - Access (Doors)
7 - Charging
8 - Resident (Long term "calendar" view)

* Rest (there isn't any need to check these in webapp yet) *
3 - Device
4 - API
5 - Internal API
6 - No log

*/

export const permissionChecker = ({ selectedLocation, permission }) => {

	// Check if billing data is present
	const isBillingDataPresent = !!(
		(
			selectedLocation?.billing?.business_id &&
			selectedLocation?.billing?.customer_name &&
			selectedLocation?.billing?.contact_email &&
			selectedLocation?.billing?.contact_name &&
			selectedLocation?.billing?.invoice_address &&
			selectedLocation?.billing?.invoice_operator
		) /* &&
		selectedLocation?.billing?.invoice_reference */
	);

	// If billing data is not present, navigate user to location detail page

	if (!isBillingDataPresent) {
		return;
	}

	// For all other permissions, return true or false based on whether the permission is found
	const hasPermission =
		selectedLocation?.location_permissions?.some(
			(obj) => obj.permission_id === permission
		) ?? false;

	return hasPermission;
};
